import { AxiosResponse } from "axios";
import { axiosConfig } from "../../config/api/configApi";
import { IBodyRequestDataPost } from "../../types/roleManagement";
import { Key } from "react";
import { axiosConfigV2 } from "../../config/api/configApiv2";

export const getDetailQuestionBank: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.get(`/question-bank/get-detail-unit-bank/${id}`);
};

export const getDetailQuestionBankMinistry: (
  id: any
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(`/question-bank/censor/${id}`);
};

export const putApproveQuestionBank: (
  param: any
) => Promise<AxiosResponse<any>> = (param) => {
  return axiosConfigV2.put(`/question-bank/censor/approve`, param);
};

export const postCreateQuestionBank: (
  param: any
) => Promise<AxiosResponse<any>> = (param) => {
  return axiosConfigV2.post(`/question-bank/create-new-quiz-bank`, param);
};

export const postCreateQuestionBankConnect: (
  param: any
) => Promise<AxiosResponse<any>> = (param) => {
  return axiosConfigV2.post(
    `/question-bank/create-new-quiz-connect-bank`,
    param
  );
};

export const putUpdateQuestionBank: (
  param: any
) => Promise<AxiosResponse<any>> = (param) => {
  return axiosConfigV2.put(`/question-bank/update-quiz-bank`, param);
};

export const putUpdateQuestionBankConnect: (
  param: any
) => Promise<AxiosResponse<any>> = (param) => {
  return axiosConfigV2.put(`/question-bank/update-quiz-connect-bank`, param);
};

export const getQuestionDetail: (id: any) => Promise<AxiosResponse<any>> = (
  id
) => {
  return axiosConfigV2.get(`/question-bank/get-quiz-bank/${id}`);
};

export const getQuestionDetailHistory: (
  id: any
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(
    `question-bank/get-quiz-question-bank-approved-history/${id}`
  );
};

export const getQuestionBankDetailHistory: (
  id: any
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2.get(
    `question-bank/get-unit-question-bank-approved-history/${id}`
  );
};

export const createQuizIntoBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post("/question-bank/add-quiz-to-question-bank", data);
};

export const createQuizDraftIntoBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post("/question-bank/add-quiz-draft-to-question-bank", data);
};

export const createQuizConnectIntoBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(
    "/question-bank/add-quiz-connect-to-question-bank",
    data
  );
};

export const createQuizDraftConnectIntoBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(
    "/question-bank/add-quiz-draft-connect-to-question-bank",
    data
  );
};

export const updateQuizInBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.put(
    `/question-bank/update-quiz-in-question-bank?id=${data.id}`,
    data
  );
};

export const updateQuizDraftInBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.put(
    `/question-bank/update-quiz-draft-in-question-bank?id=${data.id}`,
    data
  );
};

export const updateQuizConnectInBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.put(
    `/question-bank/update-quiz-connect-in-question-bank?id=${data.id}`,
    data
  );
};

export const updateQuizDraftConnectInBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.put(
    `/question-bank/update-quiz-draft-connect-in-question-bank?id=${data.id}`,
    data
  );
};

export const getQuizDetailInBank: (
  quizId: number
) => Promise<AxiosResponse<any>> = (quizId) => {
  return axiosConfigV2.get(
    `/question-bank/get-quiz-detail-in-question-bank/${quizId}`
  );
};

export const deleteQuizFromBank: (
  quizId: number
) => Promise<AxiosResponse<any>> = (quizId) => {
  return axiosConfigV2.delete(`/question-bank/delete-quiz/${quizId}`);
};

export const searchQuizInQuestionBank: (
  data: Partial<any>
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(
    `/question-bank/search-quiz-in-question-bank`,
    data
  );
};

export const getDetailQuizInBank: (
  quizId: Partial<any>
) => Promise<AxiosResponse<any>> = (quizId) => {
  return axiosConfigV2.get(
    `/question-bank/get-quiz-detail-in-question-bank/${quizId}`
  );
};

export const searchQuestionBanks: (
  payload: Partial<any>
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(`/question-bank/search-page-unit-bank`, payload);
};

export const addQuizzesFromQuestionBank: (
  payload: Partial<any>
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.post(
    `/mooc-course-block-quiz/add-quiz-from-question-bank`,
    payload
  );
};

export const saveQuizVersionInQuestionBank: (
  payload: Partial<any>
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.put(
    `/question-bank/save-quiz-version-in-question-bank?id=${payload.id}`,
    payload
  );
};

export const saveQuizConnectVersionInQuestionBank: (
  payload: Partial<any>
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2.put(
    `/question-bank/save-quiz-version-connect-in-question-bank?id=${payload.id}`,
    payload
  );
};
